export default "__VITE_ASSET__r6gbyuNN__"